export default class LicenceExperienceFFTRI {
    prix = 0;
    receivePromo = 0;
    sendInvoice = 1;
    health_form = {};
    id_course = null;
    type_licence_experience = "";
    confirmed = false;
    id_federation = null;
    numero_licence_etrangere = "";

    constructor() {}

    set(data) {
        if (!data) return;
        for (const [key, value] of Object.entries(data)) {
            if (this.hasOwnProperty(key)) {
                this[key] = value;
            }
        }
        this.prix = data.prix != null ? parseFloat(data.prix) : 0;
        this.receivePromo = data.receivePromo == 1 || data.receivePromo === true ? 1 : 0;
        this.sendInvoice = data.sendInvoice == 0 || data.sendInvoice === false ? 0 : 1;
        this.health_form = data.health_form || {};
        this.id_course = data.id_course != null ? data.id_course : null;
        this.type_licence_experience = data.type_licence_experience || "";
        this.confirmed = data.confirmed === true || data.confirmed === 1 || data.confirmed === "1";
        const fed = parseInt(data.id_federation, 10);
        this.id_federation = !isNaN(fed) && fed > 0 ? fed : null;
        this.numero_licence_etrangere = (data.numero_licence_etrangere || "").trim();
    }

    has_wt_foreign_licence() {
        const id = parseInt(this.id_federation, 10);
        const num = (this.numero_licence_etrangere || "").trim();
        return id > 0 && num.length >= 2;
    }

    is_active_in_cart() {
        if (!this.confirmed) {
            return false;
        }
        const prix = parseFloat(this.prix);
        if (!isNaN(prix) && prix > 0) {
            return true;
        }
        return this.has_wt_foreign_licence() && prix === 0;
    }

    update_cart() {
        const cart = { prix: 0, nb_articles: 0 };
        if (this.is_active_in_cart()) {
            cart.prix = parseFloat(this.prix) || 0;
            cart.nb_articles = 1;
        }
        return cart;
    }

    toPayload() {
        return {
            prix: this.prix,
            receivePromo: this.receivePromo,
            sendInvoice: this.sendInvoice,
            health_form: this.health_form,
            id_course: this.id_course,
            type_licence_experience: this.type_licence_experience,
            confirmed: this.confirmed,
            id_federation: this.id_federation,
            numero_licence_etrangere: this.numero_licence_etrangere,
        };
    }
}
